import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { PlayerProvider } from "@/context/SpotifyPlayerContext";
import Nav from "@/components/site/Nav";
import SocialRail from "@/components/site/SocialRail";
import Home from "@/pages/Home";
import BlogPost from "@/pages/BlogPost";
import { getProfile } from "@/lib/api";

function SmoothScroll() {
  const location = useLocation();
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  const [socials, setSocials] = useState([]);
  useEffect(() => {
    getProfile()
      .then((p) => setSocials(p.socials || []))
      .catch(() => {});
  }, []);

  return (
    <div className="App grain bg-[#050505] min-h-screen">
      <BrowserRouter>
        <PlayerProvider>
          <SmoothScroll />
          <Nav />
          <SocialRail socials={socials} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Toaster
            theme="dark"
            position="top-center"
            toastOptions={{ style: { background: "#0a0a0a", border: "1px solid #262626", color: "#FAFAFA" } }}
          />
        </PlayerProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
